// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import { ClientTable } from 'vue-tables-2'
import VeeValidate from 'vee-validate'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import loggingService from './services/util/loggingService'
import dateService from './services/util/dateService'
import _ from 'lodash/lodash.min.js'
import 'tinymce/tinymce'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/table'
import 'tinymce/plugins/paste'
import 'tinymce/themes/modern/theme'
import 'tinymce/skins/lightgray/skin.min.css'
import 'tinymce/skins/lightgray/content.min.css'
import 'vue-select/dist/vue-select'
import vueSmoothScroll from 'vue-smooth-scroll'
import VueTinymce from 'vue-tinymce'
import IdleVue from 'idle-vue'
import vSelect from 'vue-select'
import vmodal from 'vue-js-modal'
import getAppConfig from '../static/config/config.js'

async function InitializeApp () {
    var isDebug = false

    //get appConfig json and set to vue global
    var appConfig = await getAppConfig()
    Vue.prototype.$appConfig = appConfig

    Vue.use(ClientTable, {}, false)
    Vue.use(VeeValidate)
    Vue.use(ElementUI, { locale })
    Vue.use(VueTinymce)
    Vue.use(vueSmoothScroll)
    Vue.use(vmodal, { componentName: 'vmodal' })

    Vue.component('v-select', vSelect)

    //Idle-vue
    const eventsHub = new Vue()

    Vue.use(IdleVue, {
        eventEmitter: eventsHub,
        store,
        idleTime: 3600000, // 60 minutes,
        startAtIdle: false
    })

    Vue.config.productionTip = false

    // Axios
    var instance = axios.create({
        baseURL: appConfig.api_url
    })

    //set http requests timeout to 5min
    instance.defaults.timeout = 300000

    instance.interceptors.request.use(function (config) {
        loggingService.log(isDebug, 'main.js - (axios) request', 'url: ' + config.url)
        store.commit('startHttpRunning')

        //check that the token is unexpired before any request
        var currentTime = (new Date()).getTime()
        if (currentTime < JSON.parse(localStorage.getItem('expires_at'))) {
            config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('id_token')
        }

        return config
    }, function (error) {
        loggingService.log(isDebug, 'main.js - (axios - shpo) request - error', error)

        return Promise.reject(error)
    })

    instance.interceptors.response.use(function (response) {
        loggingService.log(isDebug, 'main.js - (axios - shpo) response', 'url: ' + response.config.url)

        store.commit('stopHttpRunning')

        return response
    }, function (error) {
        loggingService.log(isDebug, 'main.js - (axios - shpo) request - response', error)
        store.commit('stopHttpRunning')

        var errorObject = {
            id: _.uniqueId('error_'),
            time: dateService.toStringNow(),
            url: error.config.url.replace(error.config.baseURL, ''),
            status: error.response ? error.response.status + ' - ' : '',
            message: error.message,
            stack: error.stack
        }

        store.commit('addError', errorObject)

        return Promise.reject(error)
    })

    Vue.prototype.$http = instance
    Vue.prototype.$httpRunning = false

    /* eslint-disable no-unused-vars */
    const app = new Vue({
        router: router,
        store,
        render: h => h(App)
    }).$mount('#app')
}
InitializeApp()




// WEBPACK FOOTER //
// ./src/main.js